const aaa = [

	{
		path: "moneypk",
		component: () => import("@/views/shuju/moneypk.vue"),
		meta:{title:'业绩pk'},
	},
	
]
export default aaa;